export default __webpack_public_path__ + "static/sh-ac-bb210c27075429fa8f5cd17dcdc9fd0f.svg";